import utils from 'helpers/utils';
import {useServiceStatus} from 'stores/hooks/service';
import {useServiceApiMutation, useServiceApiQuery} from 'stores/hooks/query';

const path = utils.servicePath(import.meta.url);

export function useViewStatus () {
  return useServiceStatus(path);
}

export function useViewList ({search, filter, sort, page, pageSize, ...rest}, queryOptions = {}) {
  return useServiceApiQuery(path, 'list', {search, filter, sort, page, pageSize, ...rest}, queryOptions);
}

export function useViewAdd (mutationOptions = {}) {
  return useServiceApiMutation(path, 'post', {}, {
    refetchContext: true,
    ...mutationOptions
  });
}

export function useViewUpdate (mutationOptions = {}) {
  return useServiceApiMutation(path, 'patch', {}, mutationOptions);
}

export function useViewTouch (mutationOptions = {}) {
  return useServiceApiMutation(path, 'patch', {}, {
    overridePath: 'views/:viewId/touch',
    ...mutationOptions
  });
}

export function useViewDelete (mutationOptions = {}) {
  return useServiceApiMutation(path, 'delete', {}, {
    refetchContext: true,
    ...mutationOptions
  });
}

export function useViewGet ({personId}, queryOptions = {}) {
  return useServiceApiQuery(path, 'get', {personId}, queryOptions);
}

